import { render, staticRenderFns } from "./responses.vue?vue&type=template&id=21de8980&scoped=true&"
import script from "./responses.vue?vue&type=script&lang=js&"
export * from "./responses.vue?vue&type=script&lang=js&"
import style0 from "./responses.vue?vue&type=style&index=0&id=21de8980&prod&lang=scss&"
import style1 from "./responses.vue?vue&type=style&index=1&id=21de8980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21de8980",
  null
  
)

export default component.exports